var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStoreGraphicDeliveryUnavailable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.985 13.415V.61A.608.608 0 0019.38 0H3.634a.608.608 0 00-.606.61v12.805h16.957z",
    fill: "#558B2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.197 7.927v1.83h-3.028v1.219h3.028c.587 0 1.21-.428 1.21-1.22v-1.83h-1.21z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.014 8.537c0 .337-.272.61-.606.61h-1.211a.608.608 0 01-.606-.61V4.878c0-.337.271-.61.606-.61h1.21c.335 0 .607.273.607.61v3.659z",
    fill: "#7CB342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.845 9.756H1.817v-1.83H.606v1.83c0 .792.623 1.22 1.21 1.22h3.029v-1.22z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.537c0 .337.271.61.606.61h1.21a.608.608 0 00.606-.61V4.878a.608.608 0 00-.605-.61H.606a.608.608 0 00-.606.61v3.659zm18.169 4.878H4.845V4.268c0-.673.542-1.22 1.211-1.22h10.901c.669 0 1.212.547 1.212 1.22v9.147z",
    fill: "#7CB342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.957 4.878a.608.608 0 00-.605-.61h-9.69a.608.608 0 00-.606.61v4.878c0 .337.272.61.606.61h9.69a.608.608 0 00.605-.61V4.878z",
    fill: "#2B590A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.056 18.293c0-.338-.27-.61-.605-.61H3.634a.607.607 0 00-.606.61v3.048c0 .338.27.61.606.61H5.45a.607.607 0 00.605-.61v-3.048zm13.93 0c0-.338-.271-.61-.606-.61h-1.817a.607.607 0 00-.606.61v3.048c0 .338.271.61.606.61h1.817a.607.607 0 00.605-.61v-3.048z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.591 13.415c0-.674-.543-1.22-1.211-1.22H3.634c-.67 0-1.212.546-1.212 1.22v4.878c0 .673.543 1.22 1.212 1.22H19.38c.668 0 1.211-.547 1.211-1.22v-4.878z",
    fill: "#7CB342"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M6.662 12.195h9.69v6.098h-9.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.662 13.415h9.69v1.22h-9.69v-1.22zm0 2.439h9.69v1.22h-9.69v-1.22z",
    fill: "#546E7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.24 14.024c-.67 0-1.212.546-1.212 1.22 0 .673.542 1.22 1.211 1.22.67 0 1.212-.547 1.212-1.22 0-.674-.543-1.22-1.212-1.22zm14.534 0c-.669 0-1.211.546-1.211 1.22 0 .673.542 1.22 1.211 1.22.67 0 1.211-.547 1.211-1.22 0-.674-.542-1.22-1.21-1.22z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.944 12.805c-3.345 0-6.056 2.73-6.056 6.097 0 3.368 2.711 6.098 6.056 6.098S25 22.27 25 18.902c0-3.367-2.711-6.097-6.056-6.097z",
    fill: "#D93F22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.234 16.351l1.832 1.832 1.762-1.762c.163-.163.453-.137.648.058.196.195.222.486.059.649l-1.762 1.762 1.801 1.801c.163.163.137.454-.058.649s-.486.221-.649.058l-1.801-1.801-1.871 1.87c-.163.164-.454.137-.649-.058s-.221-.485-.058-.648l1.87-1.871-1.83-1.832c-.164-.163-.137-.453.058-.648s.486-.222.648-.059z",
    fill: "#FFF"
  }))));
}

export default SvgStoreGraphicDeliveryUnavailable;